export default __webpack_public_path__ + "static/media/04_photo.d8e6ff50.jpg";